import type { ApiBody, ApiQuery } from '../../../shared/api/contracts'
import { apiRequest, apiPost, apiPut, apiDelete } from './transport'

export async function fetchSubcategories(params?: ApiQuery<'GET /admin/subcategories'>, signal?: AbortSignal) {
  const u = new URLSearchParams()
  if (params?.category) u.set('category', params.category)
  if (params?.q) u.set('q', params.q)
  if (params?.includeArchived) u.set('includeArchived', 'true')
  const qs = u.toString()
  return apiRequest<'GET /admin/subcategories'>(`/admin/subcategories${qs ? `?${qs}` as const : ''}`, { signal })
}

export async function createSubcategory(payload: ApiBody<'POST /admin/subcategories'>, signal?: AbortSignal) {
  return apiPost<'POST /admin/subcategories'>('/admin/subcategories', payload, signal)
}

export async function updateSubcategory(id: string, payload: ApiBody<'PUT /admin/subcategories/:id'>, signal?: AbortSignal) {
  return apiPut<'PUT /admin/subcategories/:id'>(`/admin/subcategories/${encodeURIComponent(id)}`, payload, signal)
}

export async function archiveSubcategory(id: string, signal?: AbortSignal) {
  return apiDelete<'DELETE /admin/subcategories/:id'>(`/admin/subcategories/${encodeURIComponent(id)}`, signal)
}
